'use client';

import { createContext, useContext } from 'react';
const PublicUploadContext = createContext(null);

/**
 * Wraps an anonymous form (the public job apply page, the talent-pool apply page) so its file fields
 * upload through that page's public upload endpoint instead of the signed-in `/api/storage/upload`.
 */
export const PublicUploadProvider = ({
  target,
  children
}) => <PublicUploadContext.Provider value={target}>{children}</PublicUploadContext.Provider>;

/** The public upload target when inside a `PublicUploadProvider`, else null (signed-in upload). */
export const usePublicUploadTarget = () => useContext(PublicUploadContext);